export default __webpack_public_path__ + "static/media/settings.b9c9a421.svg";